import React, { useContext } from 'react'
import { store } from '../../stores/graphics_menu'
import StickyBar from '../shared/StickyBar'
import Filter from '../shared/Filter'
import debounce from 'debounce'

export default function Search() {
  const { loading, filter, actions, dispatch } = useContext(store)

  const setFilter = (value) => {
    dispatch({ type: actions.SET_FILTER, payload: value });
  }

  const debouncedSetFilter = debounce(setFilter, 300)

  return !loading && (
    <StickyBar className="mb-4">
      <Filter title="Filter graphics…" query={filter} onChange={debouncedSetFilter} className="col-12 col-md ps-3" />
    </StickyBar>
  )
}
